import { NSARouterMakerResult, NSAHomePage } from "namirasoft-account-react";
import { AlarmLayout } from "../AlarmLayout";
import { AlarmProps } from "../AlarmProps";

interface HomePageProps extends NSARouterMakerResult, AlarmProps { }

export default function HomePage(props: HomePageProps)
{
    return (
        <AlarmLayout
            {...props}
        >
            <NSAHomePage
                {...props}
            />
        </AlarmLayout>
    );
}